import { map } from 'rxjs/operators'
import { ofType, StateObservable } from 'redux-observable'
import { syncUiType } from '../../../actions/docs/syncUi'
import { State, ReduxAction } from '../../../reducers/reducerType'
import { layoutsActions } from '../../../slices/layouts'
import { Observable } from 'rxjs'

const updateLayouts$ = (actions$: Observable<ReduxAction>, state$: StateObservable<State>) => actions$.pipe(
  ofType(syncUiType.SET_SYNC_LAYOUTS),
  map(() => layoutsActions.setLayout(state$.value.syncUi.layouts))
)

export default updateLayouts$
